// extracted by mini-css-extract-plugin
module.exports = {"contain":"Loader_contain__3EKvy","logo":"Loader_logo__3ksC0","loadText":"Loader_loadText__Nm_Ic"};